import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { AffiliateCTA } from './AffiliateCTA';
type StickyCTAProps = {
  label: string;
  affiliateUrl: string;
};
export function StickyCTA({
  label,
  affiliateUrl
}: StickyCTAProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.9);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-255" data-mp="1hgoi2a98hbdh">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 24
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-accent-deep/70 bg-ink/95 px-4 pb-5 pt-4 backdrop-blur-md lg:hidden" data-id="element-256" data-mp="1hfn705s7wovr">
          <AffiliateCTA label={label} href={affiliateUrl} className="w-full" data-id="element-257" data-mp="3fbhzipyo6yx3" />
        </motion.div>}
    </AnimatePresence>;
}